<template>
<div class="grid h100" style="grid-template-columns: auto 1fr auto; grid-template-rows: auto auto" v-loading="loading">
<!-- <div class="grid h100 w100" v-if="loading"><circle4></circle4></div> -->
<navbar :hotel="hotel" :settings="settings" :ombrelli="ombrelli" :addombrid="addombrid" :addombrell="addombrell" :editCanvas="editCanvas" :edit="edit" :getOmbrelli="getOmbrelli"></navbar>

    <!-- <div class="h100 w20"></div> -->
  <!-- <div style="overflow: auto;" :style="{ width: windowWidth + 'px' }"> -->

  <div ref="canvas" style="display: grid; justify-items: center; align-content: start; align-content: start; overflow: auto; height: 100vh; padding: 0px;" >

  <div>
  <p>
     <el-date-picker
      v-model="today"
      type="date"
      placeholder="Pick a day"
      v-on:change="changeDate()"
      :picker-options="datePickerOptions"
      v-if="!edit">
    </el-date-picker>

<!--     <el-date-picker
      v-model="rangepicker"
      type="daterange"
      range-separator="al"
      start-placeholder="Data inizio"
      end-placeholder="Data fine"
      v-on:change="changeRange()"
      :picker-options="datePickerOptions"
      v-if="!edit">
    </el-date-picker> -->

  </p>

  </div>  

  <!-- <p v-for="ombrello in ombrelli">{{ombrello}}</p> -->
  <!-- <p v-for="ombrello in ombrelli">{{ombrello}}</p> -->
  
    <!-- <h1>{{hotel.hotelname}} - {{hotelid}}</h1> -->

    <!-- {{hotel.poolsettings}} -->
    <!-- {{ombrellos}} -->

<!--     <VueDragResize :snapToGrid="true" :gridX="200" :gridY="200" class="pool grid" style="align-content: center; justify-content: center;" v-for="(pool, index) in hotel.pools" :key="pool._id" :isActive="edit" :x="pool.x" :y="pool.y" :w="pool.width" :h="pool.height" :z="997" v-on:resizing="(left, top, width, height) => pooldrag(index, left, top, width, height)" :isDraggable="edit" @dragstop="(left, top, width, height) => pooldrag(index, left, top, width, height)" :isResizable="edit">
    <a v-on:click="removePool(index)" style="z-index: 999;" class="btn" v-if="edit">remove</a>
    <span class="fas fa-swimming-pool" v-if="!edit" v-bind:style="{ fontSize: pool.width / 8 + 'px' }"></span>
    </VueDragResize> -->

    <div  :style="{ width: windowWidth + 'px', height: windowHeight + 'px' }" style="position: relative;" class="h100">

        <VueDragResize :preventActiveBehavior="true" :parentW="windowWidth" :parentH="windowHeight" :parentLimitation="true"  class="grid ombrello" v-for="(ombrello, index) in ombrelli" :key="ombrello._id" :isActive="edit" @clicked="edit ? noshow() : show(ombrello)" :x="ombrello.x" :y="ombrello.y" :w="ombrello.width" :h="ombrello.height"  v-on:resizing="resize" :isDraggable="edit" @dragstop="(left, top, width, height) => onResizing(index, left, top, width, height)" :isResizable="false">

          <div class="grid seat" v-if="!ombrello.free" :class="{ minimal : !hotel.poolsettings.chairs || !hotel.poolsettings.beds }" v-on:click="edit ? noshow() : show(ombrello)">

          <span v-if="edit" class="deleteombrello"><i class="fas fa-trash" v-on:click="deleteOmbrello(index)"></i></span>

          <div class="grid header" :class="{ single : !hotel.poolsettings.chairs || !hotel.poolsettings.beds, hidden : !hotel.poolsettings.chairs && !hotel.poolsettings.beds }">
            <img src="../assets/img/beach-deckchair-.png" v-if="hotel.poolsettings.beds">
            <img src="../assets/img/beach-chair.png" v-if="hotel.poolsettings.chairs">

            <span class="grid" v-if="hotel.poolsettings.chairs"><a v-on:click="removechair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.chairs}}<a v-on:click="addchair(index, ombrello.chairs, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>

            <span class="grid" v-if="hotel.poolsettings.beds"><a v-on:click="removebed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-minus-square"></span></a>{{ombrello.beds}}<a v-on:click="addbed(index, ombrello.beds, ombrello._id, hotelid)"><span class="fa fa-plus-square"></span></a></span>
          </div>

          <el-popover
            placement="top-start"
            :title="'Dettagli ombrello ' + ombrello.ombrid"
            width="auto"
            trigger="hover"
            v-if="!hotel.poolsettings.guest && !hotel.poolsettings.room"
            fit="true"
            :content="ombrello.guestsinday[0].name">
            <el-table :data="ombrello.guestsinday" style="width: 100%;">
              <el-table-column width="auto" property="room" label="Stanza"></el-table-column>
              <el-table-column :min-width="100" property="name" label="Nome"></el-table-column>
              <el-table-column width="120" property="arrival" label="Arrivo"></el-table-column>
              <el-table-column width="120" property="departure" label="Partenza"></el-table-column>
            </el-table>
            <el-button slot="reference"><i class="fas fa-info-circle"></i></el-button>
          </el-popover>

          <div class="grid ident" v-if="hotel.poolsettings.room || hotel.poolsettings.guest">
          <!-- {{ombrello.guestsinday}} -->
            <span class="room" v-if="hotel.poolsettings.room">{{ombrello.guestsinday[0].room}}</span>
            <span v-if="ombrello.guest && hotel.poolsettings.guest" v-on:click="show(ombrello)">{{ombrello.guestsinday[0].name}}</span>
            <span v-if="!ombrello.guest && hotel.poolsettings.guest" v-on:click="show(ombrello)">no guest name</span>
            <span class="room" v-if="ombrello.guestsinday.length > 1">{{ombrello.guestsinday[1].room}}</span>
            <span v-if="ombrello.guest && ombrello.guestsinday.length > 1" v-on:click="show(ombrello)">{{ombrello.guestsinday[1].name}}</span>
          </div>
          <div class="grid data" :class="{ minimal : !hotel.poolsettings.chairs || !hotel.poolsettings.beds, hidden : !hotel.poolsettings.arrival }">
            <div class="grid nr">{{ombrello.ombrid}}</div>
            <div class="grid date" v-if="hotel.poolsettings.arrival || hotel.poolsettings.departure" :class="{ hidden : !hotel.poolsettings.arrival }">
              <span><span class="fa fa-chevron-right"></span> {{ombrello.arrival}}</span>
              <span><span class="fa fa-chevron-left"></span> {{ombrello.departure}}</span>
            </div>
          </div>
        </div>

          <div class="grid seat free drop" :id="ombrello._id" v-if="ombrello.free && ombrello.location === 'canvas'" v-on:click="edit ? noshow() : show(ombrello)">
          <span v-if="edit" class="deleteombrello" ><i class="fas fa-trash" v-on:click="deleteOmbrello(index)"></i></span>
            <div class="grid nr" :id="ombrello._id">{{ombrello.ombrid}}</div>
            <!-- <span>{{ombrello._id}}</span> -->
          </div>

        </VueDragResize>

        </div>

    </div>

    <div class="grid overview" >

      <el-input placeholder="Nome ospite o numero camera" v-model="query" ></el-input>

      <h2 v-if="overview.arrivals.length > 0">Check In</h2>

      <div v-if="overview.arrivals.length > 0" class="grid arrivals">
        <span class="arrival" v-for="arrival in filteredArrivals">{{arrival.ombrid}} - {{arrival.guest.name}}@{{arrival.guest.room}}</span>  
      </div>

      <h2 v-if="overview.departures.length > 0">Check Out</h2>

      <div v-if="overview.departures.length > 0" class="grid departures">
        <span class="departure" v-for="departure in filteredDepartures">{{departure.ombrid}} - {{departure.guest.name}}@{{departure.guest.room}}</span>
      </div>

      <hr>

      <div class="grid stays">
        <span class="stay" v-for="stay in filteredStays">{{stay.ombrid}} - {{stay.guest.name}}@{{stay.guest.room}}</span>
      </div>

    </div>

    <Hello :ombrellos="ombrellos" :hotel="hotel" :disabledDates="disabledDates" :range="range" v-on:changeOmbrellodate="onChange"></Hello>

  
</div>
</template>

<script>
  import Vue from 'vue'
  import {Circle4} from 'vue-loading-spinner'
  import datepicker from 'vue-date'
  import {DateRange} from 'vue-date-range'
  import moment from 'moment'
  import Navbar from '@/components/Navbar'
  import Hello from '@/components/Hello-World'
  import { Drag, Drop } from 'vue-drag-drop'
  import VueDragResize from 'vue-drag-resize'
  // import EmbeddedSlack from 'embedded-slack'
  // const chat = new EmbeddedSlack({
  //   containerId: 'embedded-slack',
  //   channel: 'C03M1FH6Y',
  //   token: 'xoxp-3715527188-3715527214-346873012933-85307408b261ae33e2a178e9a2c4914c'
  // })
  var host = process.env.ROOT_API
  // var host = 'http://drop3.drophost.it:44534'
  export default {
    name: 'pool',
    props: ['auth', 'authenticated'],
    data () {
      return {
        loading: true,
        hotel: '',
        secret: '',
        ombrelli: '',
        style: '',
        hotelid: '',
        ombrellos: '',
        today: moment().format('YYYY-MM-DD'),
        overview: {
          arrivals: [],
          departures: [],
          stays: []
        },
        langs: [{
          lang: 'it'
        }, {
          lang: 'de'
        }],
        addombrello: {
          ombrid: ''
        },
        query: '',
        date: ['2016-10-16', '2024-10-05'],
        lang: 'it',
        rangepicker: [],
        range: {
          startDate: moment(),
          endDate: ''
        },
        datePickerOptions: {
          firstDayOfWeek: 1
        },
        firstDayOfWeek: 1,
        editombrid: false,
        dragging: null,
        lock: null,
        draggable: true,
        location: 'canvas',
        edit: false,
        disabledDates: []
      }
    },
    components: {
      datepicker,
      Circle4,
      DateRange,
      'Navbar': Navbar,
      Hello,
      Drag,
      Drop,
      VueDragResize
      // EmbeddedSlack
      // chat
    },
    sockets: {
      connect: function () {
        console.log('socket connected')
      },
      stream: function (val) {
        console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
        console.log(val.hotelid)
        if (val.hotelid === this.hotelid) {
          console.log('an umbrella was updated')
          this.getOmbrelli()
        }
      },
      disconnect: function () {
        console.log('socket error')
        this.$notify({
          group: 'foo',
          title: 'Error loading Data',
          text: 'I´ll fix it in a few',
          type: 'warning',
          duration: 5000
        })
      }
    },
    methods: {
      changeDate () {
        console.log(moment(this.today).format('YYYY-MM-DD'))
        this.today = moment(this.today).format('YYYY-MM-DD')
        // this.range.startDate = moment(this.today)
        this.getOmbrelli()
        this.rangeview = false
      },
      changeRange () {
        this.loading = true
        // console.log(moment(this.rangepicker).format('YYYY-MM-DD'))
        var start = moment(this.rangepicker[0], 'YYYY-MM-DD')
        var end = moment(this.rangepicker[1], 'YYYY-MM-DD')
        var range = moment.range(start, end)
        var dates = Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'))
        // console.log('range picker dates: ', dates)
        this.rangestyle = 'grid-template-rows: repeat(' + dates.length + ', 1fr);'
        this.rangeviewdata = dates
        this.rangeview = true
        this.ombrelli.forEach((ombrello, indexo) => {
          Vue.set(this.ombrelli[indexo], 'dates', [])
          dates.forEach((date, indexd) => {
            this.ombrelli[indexo].dates.push({date: moment(date).format('DD'), day: moment(date).format('dd'), guests: [], free: true})
            ombrello.guests.forEach((guest, index) => {
              if (moment(date).isBetween(guest.arrival, guest.departure, null, this.hotel.singledaybooking ? '[]' : '[)')) {
                this.ombrelli[indexo].dates[indexd].guests.push(guest)
                this.ombrelli[indexo].dates[indexd].free = false
              } else {
              }
            })
          })
        })
        this.loading = false
      },
      noshow () {},
      deleteOmbrello (index) {
        console.log('deleteOmbrello: ', index)
        this.ombrelli.splice(index, 1)
      },
      getOverview () {
        this.overview.arrivals = []
        this.overview.departures = []
        this.overview.stays = []
        this.ombrelli.forEach((ombrello, indexo) => {
          // console.log('ombrello: ', ombrello)
          // this.ombrelli.push(ombrello)
          ombrello.guests.forEach((guest, index) => {
            console.log('guest: ', guest)
            // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
            if (moment(this.today).isSame(guest.arrival)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
              console.log(ombrello.ombrid + ' is coming today: ' + guest.arrival)
              this.overview.arrivals.push({guest: guest, ombrid: ombrello.ombrid})
            } else if (moment(this.today).isSame(guest.departure)) {
            // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
              console.log(ombrello.ombrid + ' is starting today: ' + guest.departure)
              this.overview.departures.push({guest: guest, ombrid: ombrello.ombrid})
            } else if (moment(this.today).isBetween(guest.arrival, guest.departure, null, '()')) {
              console.log(ombrello.ombrid + ' is staying here today: ' + guest.departure)
              this.overview.stays.push({guest: guest, ombrid: ombrello.ombrid})
            }
          })
        })
      },
      // filter (query) {
      //   console.log(this.query, this.overview.arrivals.filter(item => item.ombrid === this.query))
      //   this.filtered = this.overview.arrivals.filter(item => item.guest.name === this.query)
      // },
      editCanvas () {
        // console.log(this.edit)
        if (this.edit) {
          console.log('edit off')
          this.edit = false
          this.updategrid()
        } else {
          console.log('edit on')
          this.edit = true
        }
      },
      disabledFunc: function (dayMoment) {
        // console.log(dayMoment, moment(dayMoment).isBetween(moment('2019-04-03'), moment('2019-04-12')))
        // if (moment(dayMoment).isBetween(moment('2019-04-14'), moment('2019-04-24'))) {
        if (this.disabledDates.includes(moment(dayMoment).format('YYYY-MM-DD'))) {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return true
        } else {
          // console.log(moment(dayMoment).format('YYYY-MM-DD'))
          return false
        }
      },
      preCheckDate () {
        console.log('preCheckDate')
        this.disabledDates = []
        this.ombrellos.guests.forEach((guest, indexo) => {
          if (guest.name !== this.ombrellos.guest) {
            var start = moment(guest.arrival, 'YYYY-MM-DD')
            var end = moment(guest.departure, 'YYYY-MM-DD')
            var range = moment.range(start, end)
            var dates = Array.from(range.by('days', { excludeStart: false, excludeEnd: !this.hotel.singledaybooking })).map(m => m.format('YYYY-MM-DD'))
            Array.prototype.push.apply(this.disabledDates, dates)
            console.log('guest: ', guest.name, dates)
          }
        })
      },
      // saveOmbrello: function () {
      //   console.log(this.ombrellos)
      //   console.log(this.range['endDate'])
      //   this.$delete(this.ombrellos, '__v')
      //   this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
      //   this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
      //   this.editombrid = false
      //   this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
      //   this.ombrellos.guest = ''
      //   this.ombrellos.room = ''
      //   this.ombrellos.arrival = ''
      //   this.ombrellos.departure = ''
      //   this.ombrellos.guestsinday = []
      //   this.ombrellos.free = true
      //   console.log('ombrello: ', this.ombrellos.ombrid, this.ombrellos.guests)
      //   this.$http
      //     .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       this.$modal.hide('hello-world')
      //       this.getOmbrelli()
      //     }, (error) => {
      //       console.log(error)
      //       this.$notify({
      //         group: 'foo',
      //         title: 'Error loading Data',
      //         text: 'I´ll fix it in a few',
      //         type: 'warning',
      //         duration: 500
      //       })
      //     })
      // },
      addombrid () {
        // this.hotel.pools = []
        this.ombrelli.push({
          free: true,
          location: 'canvas',
          ombrid: this.ombrelli.length + 1,
          hotelid: this.hotel._id,
          user: this.hotel.user,
          width: 130,
          height: 145,
          guests: [],
          x: 500,
          y: 500
        })
        this.ombrellos = {
          free: true,
          location: 'canvas',
          ombrid: this.ombrelli.length + 1,
          hotelid: this.hotel._id,
          user: this.hotel.user,
          width: 130,
          height: 145,
          guests: [],
          x: 500,
          y: 500 }
        // this.updateombrello()
      },
      onResizing (id, left, top, width, height) {
        // console.log(id, left, top, width, height)
        this.ombrelli[id].left = left.left
        this.ombrelli[id].top = left.top
        this.ombrelli[id].x = left.left
        this.ombrelli[id].y = left.top
        // this.ombrelli[id].x = left.left
        // this.ombrelli[id].left = left.left
      },
      resize (newRect) {
        console.log(newRect)
        this.width = newRect.width
        this.height = newRect.height
        this.top = newRect.top
        this.left = newRect.left
      },
      pooldrag (id, left, top, width, height) {
        // console.log(id, left, top, width, height)
        this.hotel.pools[id].x = left.left
        this.hotel.pools[id].y = left.top
        this.hotel.pools[id].width = left.width
        this.hotel.pools[id].height = left.height
      },
      handleDragover (group, data, event) {
        // console.log(data)
        // console.log(group.ombrid)
        // console.log(event)
        if (!group.free) {
          event.dataTransfer.dropEffect = 'none'
        }
      },
      handleDrop (group, data, key) {
        console.log(group.ombrello.ombrid, data.target.id)
        this.moveombrello(group.ombrello, data.target.id)
        // alert(`You dropped with data: ${JSON.stringify(data)}`)
      },
      changeombrid () {
        console.log('changeombrid')
        this.editombrid = true
      },
      onChange (range) {
        this.range = range
        console.log(moment(range.endDate._d))
      },
      setRange (p) {
        if (typeof p === 'number') {
          console.log(p)
          this.range = {
            startDate: moment().add(p, 'days'),
            endDate: moment()
          }
        }
      },
      show (ombrello) {
        console.log(ombrello.arrival)
        this.ombrellos = ombrello
        this.range = {}
        if (ombrello.free) {
          this.ombrellos.items = this.hotel.items
          // this.ombrellos.chairs = this.hotel.chairs
          // this.ombrellos.beds = this.hotel.beds
        } else if (!ombrello.items) {
          this.ombrellos.items = this.hotel.items
        }
        // if (ombrello.free) {
        //   this.ombrellos.chairs = this.hotel.chairs
        //   this.ombrellos.beds = this.hotel.beds
        // }
        // if (ombrello.beds === null) { this.ombrellos.beds = this.hotel.beds }
        // this.date[0] = ombrello.arrival
        // this.date[1] = ombrello.departure
        // console.log('arrival ', moment(ombrello.arrival, 'DD.MM.YYYY'))
        if (!ombrello.free) {
          // console.log('show ombrello arrival: ', moment(ombrello.arrival).format('DD.MM.YYYY'))
          this.range.startDate = moment(ombrello.arrival)
          this.range.endDate = moment(ombrello.departure)
        } else if (this.hotel.singledaybooking) {
          this.range.startDate = moment(this.today)
          this.range.endDate = moment(this.today)
        } else {
          this.range.startDate = moment(this.today)
          this.range.endDate = moment(this.today).add(1, 'days')
        }
        // if (ombrello.departure !== '') {
        //   this.range.endDate = moment(ombrello.departure)
        // } else {
        //   this.range.endDate = moment(this.today).add(1, 'days')
        // }
        this.preCheckDate()
        this.$modal.show('hello-world')
      },
      hide () {
        this.$modal.hide('hello-world')
      },
      settings () {
        this.$modal.show('settings')
      },
      updategrid: function () {
        console.log(this.ombrelli)
        // console.log(this.range['endDate'])
        // this.editombrid = false
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/api/updategrid', { ombrelli: this.ombrelli, hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            // this.$modal.hide('hello-world')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      updatehotel: function () {
        this.$http
          .post(host + '/api/updatehotel', { hotel: this.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.$modal.hide('settings')
            // this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      // updateombrello: function () {
      //   console.log(this.ombrellos)
      //   console.log(this.range['endDate'])
      //   this.$delete(this.ombrellos, '__v')
      //   this.ombrellos.arrival = moment(this.range.startDate._d).format('YYYY-MM-DD')
      //   this.ombrellos.departure = moment(this.range.endDate._d).format('YYYY-MM-DD')
      //   this.editombrid = false
      //   // this.ombrellos.guests.push({name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure})
      //   if (this.ombrellos.free) {
      //     console.log(this.ombrellos.guests[this.ombrellos.guestnr] + ' is free so i am not updating guest data')
      //     // this.ombrellos.guests = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
      //   } else {
      //     this.ombrellos.guests[this.ombrellos.guestnr] = {name: this.ombrellos.guest, room: this.ombrellos.room, arrival: this.ombrellos.arrival, departure: this.ombrellos.departure}
      //   }
      //   this.ombrellos.guest = ''
      //   this.ombrellos.room = ''
      //   this.ombrellos.arrival = ''
      //   this.ombrellos.departure = ''
      //   this.ombrellos.guestsinday = []
      //   this.ombrellos.free = true
      //   console.log('ombrello update: ', this.ombrellos)
      //   this.$http
      //     .post(host + '/api/updateombrello', { ombrellos: this.ombrellos },
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + localStorage.jwt
      //       }
      //     },
      //     ).then((data) => {
      //       console.log(data)
      //       this.$modal.hide('hello-world')
      //       this.getOmbrelli()
      //     }, (error) => {
      //       console.log(error)
      //       this.$notify({
      //         group: 'foo',
      //         title: 'Error loading Data',
      //         text: 'I´ll fix it in a few',
      //         type: 'warning',
      //         duration: 500
      //       })
      //     })
      // },
      moveombrello: function (old, newo) {
        console.log(old, newo)
        // this.ombrellos = old
        // this.closeombrello()
        // old._id = newo
        // old.ombrid = ombrid
        // console.log(this.ombrellos)
        // this.ombrellos = newo
        this.$http
          .post(host + '/api/moveombrello', { old: old, newo: newo },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // console.log(data)
            this.dragging = null
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
            this.$notify({
              group: 'foo',
              title: 'Error loading Data',
              text: 'I´ll fix it in a few',
              type: 'warning',
              duration: 500
            })
          })
      },
      closeombrello (index) {
        console.log(this.ombrellos.guests, index)
        this.ombrellos.guests.splice(index, 1)
        console.log('updated: ', this.ombrellos.guests)
        this.ombrellos.guest = ''
        this.ombrellos.room = ''
        this.ombrellos.arrival = ''
        this.ombrellos.note = ''
        this.ombrellos.departure = ''
        this.ombrellos.guestsinday = []
        this.ombrellos.free = true
        this.$http
          .post(host + '/ombrelloni/close', { ombrellos: this.ombrellos },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            this.$modal.hide('hello-world')
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      addombrell: function () {
        console.log(this.addombrello, this.hotelid)
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized',
        // var ombrellos = this.ombrellos
          .post(host + '/ombrelloni/add', { ombrid: 'pool', hotelid: this.hotelid, location: this.location },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            // this.ombrelli = data.body.ombrells
            console.log(data)
            this.getOmbrelli()
          }, (error) => {
            console.log(error)
          })
      },
      editguest: function (index) {
        console.log(index.ombrid, index.edit)
        index.edit = true
        // Vue.set(this.ombrelli[index], 'edit', true)
      },
      saveEdit: function (index, guest) {
        // save your changes
        // this.toggleEdit(index, guest)
        console.log(index, guest)
        Vue.set(this.ombrelli[index], 'guest', guest)
      },
      getOmbrelli () {
        // console.log(localStorage.access_token)
        // this.$i18n.locale = 'en'
        this.$http
          // .get('http://srv5.ghosted.it:8000/authorized/richards',
          // .get('http://localhost:8000/authorized/' + this.$route.params.hotel,
          // .post(host + '/ombrelloni', { userid: localStorage.userid },
          .post(host + '/ombrelloni/canvas', { hotelid: this.$route.params.hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data.body)
            if (data.body.hotels === null) {
              this.$router.push('/hotel')
            }
            this.hotelid = data.body.hotels._id
            this.hotel = data.body.hotels
            if (data.body.hotels.chairs === undefined) {
              this.hotel.chairs = 1
            }
            if (data.body.hotels.beds === undefined) {
              this.hotel.beds = 1
            }
            this.style = 'grid-template-columns: repeat(' + data.body.hotels.cols + ', 1fr); grid-template-rows: repeat(' + data.body.hotels.rows + ', 284px);'
            // console.log('hotel: ' + this.hotelid)
            // console.log(data)
            // this.ombrelli = data.body.ombrells
            this.ombrelli = []
            data.body.ombrells.forEach((ombrello, indexo) => {
              // console.log('ombrello: ', ombrello)
              this.ombrelli.push(ombrello)
              ombrello.guests.forEach((guest, index) => {
                console.log('guest: ', guest)
                // console.log(moment(this.today).isBetween(guest.arrival, guest.departure))
                if (moment(this.today).isBetween(guest.arrival, guest.departure, null, this.hotel.singledaybooking ? '[]' : '[)')) {
                // if (moment('2019-04-06').isBetween('2019-04-03', '2019-04-10')) {
                  console.log(ombrello.ombrid + ' is occupied between ' + guest.arrival + ' and ' + guest.departure)
                  this.ombrelli[indexo].guest = guest.name
                  this.ombrelli[indexo].room = guest.room
                  this.ombrelli[indexo].arrival = guest.arrival
                  this.ombrelli[indexo].departure = guest.departure
                  this.ombrelli[indexo].free = false
                  this.ombrelli[indexo].note = guest.note
                  this.ombrelli[indexo].guestnr = index
                  if (guest.passid) {
                    this.ombrelli[indexo].passid = guest.passid
                  }
                  if (!guest.items) {
                    console.log('no items')
                    this.ombrelli[indexo].items = this.hotel.items
                  } else {
                    console.log(guest.items)
                    this.ombrelli[indexo].items = guest.items
                  }
                  this.ombrelli[indexo].guestsinday.push(guest)
                } else {
                }
              })
            })
            this.getOverview()
            this.loading = false
            this.$notify({
              group: 'foo',
              title: 'Hoteldata loaded',
              text: 'You are good to go',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
            this.$router.replace('/')
          })
      },
      addchair (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addchair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
            this.$notify({
              group: 'foo',
              title: 'Chair added',
              type: 'success',
              duration: 500
            })
          }, (error) => {
            console.log(error)
          })
      },
      removechair (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removechair/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'chairs', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      addbed (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr + 1
        this.$http
          .post(host + '/api/addbed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      removebed (index, nr, chair, hotel) {
        console.log(this.ombrelli)
        console.log(index, chair, hotel)
        var newchairs = nr - 1
        this.$http
          .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.jwt
            }
          },
          ).then((data) => {
            console.log(data)
            // this.loading = false
            Vue.set(this.ombrelli[index], 'beds', newchairs)
          }, (error) => {
            console.log(error)
          })
      },
      changeguest (index, chair, guest) {
        console.log(this.ombrelli)
        console.log(index, chair, guest)
        // var newchairs = nr - 1
        // this.$http
        //   .post(host + '/api/removebed/' + chair, {chairid: chair, hotelid: hotel},
        //   {
        //     headers: {
        //       'Authorization': 'Bearer ' + localStorage.jwt
        //     }
        //   },
        //   ).then((data) => {
        //     console.log(data)
        //     // this.loading = false
        //     Vue.set(this.ombrelli[index], 'beds', newchairs)
        //   }, (error) => {
        //     console.log(error)
        //   })
      }
    },
    beforeMount () {
      this.getOmbrelli()
    },
    computed: {
      hotelgrid: function () {
      // `this` points to the vm instance
        return this.hotel.cols * this.hotel.rows
      },
      userLastCount () {
        console.log(this.ombrells)
      },
      filteredArrivals () {
        console.log('filteredArrivals')
        return this.overview.arrivals.filter(post => {
          var arrivals = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var arrivalsroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          console.log(arrivals)
          if (arrivals) {
            return arrivals
          } else {
            return arrivalsroom
          }
        })
      },
      filteredDepartures () {
        return this.overview.departures.filter(post => {
          var departures = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var departuresroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (departures) {
            return departures
          } else {
            return departuresroom
          }
        })
      },
      filteredStays () {
        return this.overview.stays.filter(post => {
          var stays = post.guest.name.toLowerCase().includes(this.query.toLowerCase())
          var staysroom = post.guest.room.toLowerCase().includes(this.query.toLowerCase())
          if (stays) {
            return stays
          } else {
            return staysroom
          }
        })
      },
      windowWidth () {
        if (this.ombrelli.length === 0) return
        var highest = this.ombrelli.reduce((a, b) => Number(a.x) > Number(b.x) ? a : b)
        console.log('width: ', highest.x + 500, 'client: ', this.$refs.canvas.clientWidth)
        if ((highest.x + 500) < this.$refs.canvas.clientWidth) {
          return this.$refs.canvas.clientWidth
        } else {
          return highest.x + 500
        }
      },
      windowHeight () {
        if (this.ombrelli.length === 0) return
        var highest = this.ombrelli.reduce((a, b) => Number(a.y) > Number(b.y) ? a : b)
        console.log('height: ', highest.y + 500, 'client: ', this.$refs.canvas.clientHeight)
        // return highest.y + 500
        if ((highest.y + 500) < this.$refs.canvas.clientHeight) {
          return this.$refs.canvas.clientHeight
        } else {
          return highest.y + 500
        }
      }
    }
  }
</script>

<style>

</style>




// WEBPACK FOOTER //
// Canvas.vue?3e1f315e